import * as React from 'react';

import { IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { useAppSelector } from 'app/hooks';
import INftCard from 'interfaces/NftCard.interface';
import { selectAuth } from 'features/auth/authSlice';
// import { fetchInboxUsers } from 'utils/Firebase.util';
// import { useDispatch } from 'react-redux';

import ShareModal from './ShareModal';
import { fetchInboxUsers } from 'utils/Firebase.util';
import { useDispatch } from 'react-redux';
import { selectChat, setChatLoaded, setLoading } from 'features/auth/chatSlice';

const ShareNftModal = (props: INftCard) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const chatState = useAppSelector(selectChat);

  const handleOnClick = async () => {
    handleOpen();
    if (!chatState.chatLoaded) {
      await fetchInboxUsers(authState, dispatch, setLoading);
      dispatch(setChatLoaded());
    }
  };

  return (
    <div style={{ zIndex: 10 }}>
      <IconButton
        onClick={handleOnClick}
        sx={{
          position: 'absolute',
          overflow: 'visible',
          right: '8px',
          bottom: '6px',
          backgroundColor: 'rgba(0,0,0,0.8)',
          color: 'white',
          padding: 1,
          borderRadius: '50%',
        }}
      >
        <ShareIcon sx={{ fontSize: '0.8rem' }} />
      </IconButton>
      <ShareModal handleClose={handleClose} open={open} props={props} />
    </div>
  );
};

export default ShareNftModal;
